module.exports = {"step1":"Étape  1","step2":"Étape  2","step3":"Bon de réduction"}